import { render, staticRenderFns } from "./descriptive_balancedetails.vue?vue&type=template&id=45f3f219&scoped=true&"
import script from "./descriptive_balancedetails.vue?vue&type=script&lang=js&"
export * from "./descriptive_balancedetails.vue?vue&type=script&lang=js&"
import style0 from "./descriptive_balancedetails.vue?vue&type=style&index=0&id=45f3f219&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3f219",
  null
  
)

export default component.exports